import React from 'react';
import type { FC } from 'react';
import { RESIZE_CONFIG, SCHEDULE_START_MINUTE, TOTAL_SCHEDULE_MINUTES } from '../config/constants';

interface ResizeGridGuidesProps {
    visible: boolean;
    currentStartMinutes: number;
    currentEndMinutes: number;
    totalGridContentHeight: number;
    gridHeaderHeight: number;
    gridPadding: number;
    snapInterval?: number;
    className?: string;
}

/**
 * ResizeGridGuides component for showing visual alignment guides during resize
 * Displays snap lines and time boundaries
 */
const ResizeGridGuides: FC<ResizeGridGuidesProps> = ({
    visible,
    currentStartMinutes,
    currentEndMinutes,
    totalGridContentHeight,
    gridHeaderHeight,
    gridPadding,
    snapInterval = RESIZE_CONFIG.snapIntervalMinutes,
    className = ''
}) => {
    if (!visible) return null;

    // Calculate positions for the current start and end times
    const startOffset = currentStartMinutes - SCHEDULE_START_MINUTE;
    const endOffset = currentEndMinutes - SCHEDULE_START_MINUTE;

    const startY = ((startOffset / TOTAL_SCHEDULE_MINUTES) * totalGridContentHeight) + gridHeaderHeight + gridPadding;
    const endY = ((endOffset / TOTAL_SCHEDULE_MINUTES) * totalGridContentHeight) + gridHeaderHeight + gridPadding;

    return (
        <div className={`absolute inset-0 pointer-events-none z-15 ${className}`}>

            {/* Duration highlight area - subtle background highlight */}
            <div
                className="absolute left-0 right-0 bg-blue-50 opacity-40 border-l-2 border-blue-300"
                style={{
                    top: `${Math.min(startY, endY)}px`,
                    height: `${Math.abs(endY - startY)}px`
                }}
            />

        </div>
    );
};

export default ResizeGridGuides;